import { Routes } from '@angular/router';

export enum TabRoutePath {
  SCHEDULE = 'schedule',
  NOTIFICATIONS = 'notifications',
  PROFILE = 'profile',
}

export const TABS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./tabs.component').then(m => m.TabsComponent),
    children: [
      {
        path: TabRoutePath.SCHEDULE,
        loadChildren: () => import('../schedule/schedule.routes').then(m => m.SCHEDULE_ROUTES),
      },
      {
        path: TabRoutePath.NOTIFICATIONS,
        loadChildren: () =>
          import('../notifications/notifications.routes').then(m => m.NOTIFICATIONS_ROUTES),
      },
      {
        path: TabRoutePath.PROFILE,
        loadChildren: () => import('../profile/profile.routes').then(m => m.PROFILE_ROUTES),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: TabRoutePath.SCHEDULE,
      },
    ],
  },
];
